// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Xh-z","title":"Yh-z","cta":"Zh-z","disabled":"_h-z"};